export default {
  '*.dataset.sankey': function () {
    let dataset = this,
      clipCanvas = dataset.getClip('canvas'),
      clipCanvasInit = dataset.getClip('init');

    return {
      'linkGroup.appearing': () => {
        return [{
          initialAttr: {
            'clip-rect': clipCanvasInit
          },
          finalAttr: {
            'clip-rect': clipCanvas
          },
          slot: 'plot'
        }];
      },
      'nodeGroup.appearing': () => {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'axis'
        }];
      },
      'nodeLabelGroup.appearing': () => {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      }
    };
  }
};
